import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setDuration } from '../../../actions/filterActions';
import { clearReservationError } from '../../../actions/reservationActions';
import { RadioGroup, Radio } from '../../Radio';

import './DurationToggle.css';

class DurationToggle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: 30
    };
  }

  componentWillMount() {
    this.setToggleValue(this.props.durationInMinutes);
  }

  componentWillReceiveProps(nextProps) {
    // if durationInMinutes has been updated, call setToggleValue
    if (this.props.durationInMinutes !== nextProps.durationInMinutes) {
      this.setToggleValue(nextProps.durationInMinutes);
    }
  }

  setToggleValue = (duration) => {
    this.setState({ selectedOption: duration });
    this.props.clearReservationError();
  }

  isDisabled = () => {
    return (
      !this.props.user ||
      !this.props.user.stripePlan ||
      this.props.user.stripePlan.maxDuration === 30
    );
  }

  handleChange = (value) => {
    this.props.setDuration(value);
  }

  render() {
    if (this.isDisabled()) {
      return <div />;
    }
    return (
      <div className="DurationToggle filter-sidebar-component row no-gutters">
        <label className="col-9 mb-3">LENGTH</label>

        <div className="col-9 radio-group">
          <RadioGroup
            name="Lesson Duration"
            selectedValue={this.state.selectedOption}
            onChange={this.handleChange}
          >
            <Radio value={30} className="radio-item" label="30 mins" disabled={this.isDisabled()} />
            <Radio value={60} className="radio-item" label="60 mins" disabled={this.isDisabled()} />
          </RadioGroup>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    durationInMinutes: state.filters.durationInMinutes
  };
}

export default connect(
  mapStateToProps,
  { setDuration, clearReservationError }
)(DurationToggle);



// WEBPACK FOOTER //
// ./src/components/filters/DurationToggle/DurationToggle.js